import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Table, TextLink, ImageStamp} from "../../../components";
import {elderFamilyMembersAction} from "redux/actions";
import {useHistory} from "react-router-dom";

function EldFamilyMembersTab({clickedElder, handleCloseModal, setClickedSubscription, handleOpenSubscriptionModal}) {
    const {
        push
    } = useHistory();

    const [tableRows, setTableRows] = useState();

    // Redux actions
    const dispatch = useDispatch();
    const datas = useSelector(state => state.elderFamilyMembers);

    useEffect(() => {
        dispatch(elderFamilyMembersAction.get(clickedElder?.id));
        return () => dispatch(elderFamilyMembersAction.reset());
    }, []);

    useEffect(() => {
        let filtered = datas?.data;
        if (!filtered?.length) {
            setTableRows();
            return;
        }

        // Map table rows
        const data = filtered?.map(obj => ({
            id: obj?.family_member_id,
            elder_id: obj?.elder_id,
            user_id: obj?.user_id,
            relationship_type_id: obj?.get_relation_type?.relationship_name,
            communication_channel_id: obj?.get_comm_channel?.channel_name,
            fname: obj?.get_user?.first_name,
            lname: obj?.get_user?.last_name,
            mobileno: obj?.get_user?.mobile,
            access_level_id: obj?.get_access_level?.access_level_name,
            is_active: obj?.is_active,
            is_primary_caregiver: obj?.is_primary_caregiver,
            createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
            updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`
        }));

        setTableRows(data);
    }, [datas]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Family MemberID"
            },
            {
                title: "Elder"
            },
            {
                title: "Customer"
            },
            {
                title: "Relationship Type"
            },
            {
                title: "Communication Channel"
            },
            {
                title: "First Name"
            },
            {
                title: "Last Name"
            },
            {
                title: "Mobile No"
            },
            {
                title: "Access Level"
            },
            {
                title: "Active"
            },
            {
                title: "Primary Caregiver"
            },
            {
                title: "Created"
            },
            {
                title: "Updated"
            }
        ],
        [tableRows]
    );

    return (
        <>
            <Table
                headers={tableHeaders}
                data={tableRows}
                current={datas?.currentPage}
                totalPage={datas?.maxPages}
            />
        </>
    );
}

export default EldFamilyMembersTab;